/**
 * TODO:
 * - Password strength
 * - Recaptcha
 */
import cn from "classnames";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useTitle } from "react-use";
import * as yup from "yup";
import loginImage from "../../assets/images/login.svg";
import Button from "../../components/Button";
import { FormField } from "../../components/forms/shared";
import TextInput from "../../components/forms/TextInput";
import Logo from "../../components/Logo";
import { useMutation } from "../../helpers/forms";
import { ROUTE_HOME, ROUTE_REGISTER } from "../../routes";
import { MutationState } from "../../store/modules/types";
import { loginAsync, loginClear } from "../../store/modules/user/actions";
import { RootState } from "../../store/rootReducer";

const validationSchema = yup.object().shape({
  email: yup.string().required("Email is required.").email(),
  password: yup.string().required("Password is required.").min(8).max(30),
});

const Login = () => {
  useTitle("Login - Due");
  const history = useHistory();
  const dispatch = useDispatch();
  const year = new Date().getFullYear();
  const { login }: { login: MutationState<string> } = useSelector(
    ({ user: { login } }: RootState) => {
      return { login };
    }
  );
  const [error, setError] = useState("");

  useMutation({
    mutation: login,
    onError: (e) => {
      setError(e);
    },
    onSuccess: () => {
      history.push(ROUTE_HOME);
    },
    clear: () => {
      dispatch(loginClear());
    },
  });

  return (
    <div className="h-full flex bg-asparagus">
      <div
        className={cn(
          "flex flex-col overflow-auto w-full bg-white p-4",
          "lg:w-1/2 lg:items-center lg:justify-center lg:rounded-tr-2xl lg:rounded-br-2xl"
        )}
      >
        <Logo
          type="plain"
          className="block mb-6 lg:fixed lg:top-4 lg:left-6 w-24"
        />
        <div className="lg:p-2 w-full lg:w-8/12">
          <h1 className="text-3xl font-bold mb-6 text-gray-800">Login</h1>
          {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
          <Formik
            validateOnChange={false}
            validateOnBlur={true}
            validationSchema={validationSchema}
            initialValues={{
              email: "",
              password: "",
            }}
            onSubmit={({ email, password }) => {
              dispatch(
                loginAsync.request({
                  email,
                  password,
                })
              );
            }}
          >
            {({ values, errors, setFieldValue }) => (
              <Form>
                <FormField id="email" label="Email" error={errors.email}>
                  <TextInput
                    id="email"
                    name="email"
                    onChange={(e) => {
                      setFieldValue("email", e.target.value);
                    }}
                  />
                </FormField>
                <FormField
                  id="password"
                  label="Password"
                  error={errors.password}
                >
                  <TextInput
                    id="password"
                    type="password"
                    name="password"
                    onChange={(e) => {
                      setFieldValue("password", e.target.value);
                    }}
                  />
                </FormField>
                <Button type="submit" size="lg" block disabled={login.loading}>
                  Login
                </Button>

                <div className="text-sm text-gray-600 mt-6 text-center">
                  Don't have an account?{" "}
                  <Link
                    to={ROUTE_REGISTER}
                    className="text-primary hover:no-underline"
                  >
                    Register
                  </Link>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="lg:fixed pb-2 mt-6 text-center lg:pb-0 text-xs text-gray-500 bottom-2">
          Copyright © {year} Due Inc. All rights reserved.
        </div>
      </div>
      <div className="w-1/2 h-full items-center justify-center lg:flex hidden">
        <img className="w-6/12" src={loginImage} alt="Sign Up" />
      </div>
    </div>
  );
};

export default Login;
